import {
  apiGetExamples,
  apiCopyAssessmentFile
} from '../../common/api/assessment'

const fetchExamples = (schoolOrganisationFilter = false) => ({
  requestPrefix: 'EXAMPLES:FETCH',
  request: () =>
    apiGetExamples(schoolOrganisationFilter, {
      include:
        'assessment_file.details,assessment_file.timestamps,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.work.medium.thumb'
    })
})

const filterToSchoolOrganisation = () => ({
  type: 'EXAMPLES:FILTER_SCHOOL_ORGANISATION'
})

const filterToAll = () => ({
  type: 'EXAMPLES:FILTER_ALL'
})

const copyExample = id => ({
  requestPrefix: 'EXAMPLES:COPY',
  request: () => apiCopyAssessmentFile(id)
})

export { fetchExamples, copyExample, filterToSchoolOrganisation, filterToAll }
